<template>
  <button @click="newBudget()" class="w-full">
    <app-button-create class="border-yellow mb-5" color="yellow">
      <span class="text-yellow font-bold text-lg">予算</span>
      <span class="text-yellow font-bold text-sm">を</span>
      <span class="text-yellow font-bold text-lg">新規追加</span>
    </app-button-create>
  </button>
  <budgets-table-header></budgets-table-header>
  <budgets-table></budgets-table>
  <budget-dialog v-if="isOpen && type==='budgets'"></budget-dialog>
</template>
<script>
import { onMounted, watch } from 'vue'
import { useBudgetDialog } from '@/services/useBudgetDialog'
import BudgetsTableHeader from '@/components/layout/budgets/BudgetsTableHeader'
import BudgetsTable from '@/components/layout/budgets/BudgetsTable'
import BudgetDialog from '@/components/layout/budgets/BudgetDialog.vue'
import AppButtonCreate from '@/components/ui/AppButtonCreate'
import { useBudgets } from '@/services/useBudgets'
import { useDialog } from '@/services/useDialog'
import { useYearSelector } from '@/services/useYearSelector'

export default {
  name: 'Budgets',

  components: {
    BudgetsTableHeader,
    AppButtonCreate,
    BudgetsTable,
    BudgetDialog,
  },

  setup() {
    const { budgetDialog } = useBudgetDialog()
    const { getBudgets, resetCurrentBudget } = useBudgets()
    const { currentYear, resetYear } = useYearSelector()
    const { openDialog, isOpen, type } = useDialog()

    onMounted(async () => {
      resetYear()
      await getBudgets(currentYear.value)
    })

    watch(currentYear, async currentYear => {
      await getBudgets(currentYear)
    })

    const newBudget = () => {
      resetCurrentBudget()
      openDialog('budgets')
      budgetDialog.isPreview = false
      budgetDialog.isPreviewEnabled = false
      budgetDialog.isPreviewRegistered = false
    }

    return { ...useBudgetDialog(), newBudget, isOpen, type }
  },
}
</script>
